export default __webpack_public_path__ + "tab3_video_posterd356ac.png";